import { render, staticRenderFns } from "./process_h.vue?vue&type=template&id=55496254&scoped=true"
import script from "./process_h.vue?vue&type=script&lang=js"
export * from "./process_h.vue?vue&type=script&lang=js"
import style0 from "./process_h.vue?vue&type=style&index=0&id=55496254&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55496254",
  null
  
)

export default component.exports